exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.meta-list[data-v-cacbbd0e] {\n  margin-bottom: 30px;\n}\n.meta-item[data-v-cacbbd0e] {\n  margin-bottom: 10px;\n}\n.description[data-v-cacbbd0e] {\n  margin-bottom: 20px;\n}\n.emotion[data-v-cacbbd0e] {\n  display: inline-block;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  transform: rotate(90deg);\n  font-size: 18px;\n  line-height: 18px;\n  width: 30px;\n  height: 30px;\n  pointer-events: none;\n}\nli[data-v-cacbbd0e] {\n  list-style-type: none;\n}\n", ""]);

// exports
